var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12H10L10 0H6ZM12 0L12 12H16C19.3137 12 22 9.31371 22 6C22 2.68629 19.3137 0 16 0H12Z",
    fill: "#D76D68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillRed);
export default __webpack_public_path__ + "static/media/pill-red.9c1a9a8e527f0127335ad49b1b510bf8.svg";
export { ForwardRef as ReactComponent };